var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "match-refuse" },
    [
      _c(
        "div",
        { staticClass: "table-list" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.orderDetailTableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "order_number", label: "子订单号", width: "140" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ruigu_code", label: "锐锢编码" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "self_code", label: "三方商品编码" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "商品名", width: "280" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "spec", label: "规格" } }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "unit", label: "单位" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "send_amount", label: "实发数量" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "re_num", label: "收货数量" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cfm_num", label: "确认数量", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: "" },
                          model: {
                            value: scope.row.cfm_num,
                            callback: function($$v) {
                              _vm.$set(scope.row, "cfm_num", $$v)
                            },
                            expression: "scope.row.cfm_num"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "异常原因", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: "" },
                          model: {
                            value: scope.row.remark,
                            callback: function($$v) {
                              _vm.$set(scope.row, "remark", $$v)
                            },
                            expression: "scope.row.remark"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tool-btn" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.handleSave }
            },
            [_vm._v("保存")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.refuseDialogVisible,
            "append-to-body": true,
            center: "",
            width: "500px",
            "custom-class": "confirm-refuse-dialog",
            title: "确认提示"
          },
          on: {
            "update:visible": function($event) {
              _vm.refuseDialogVisible = $event
            }
          }
        },
        [
          _c("p", [_vm._v("信息确认后，将作为扣款处理的依据！")]),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.refuseDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: {
                    click: function($event) {
                      return _vm.handleConfirm(true)
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-066ba9b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-066ba9b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/matchRefuse.vue
// module id = null
// module chunks = 